const status = null
const userAuth = {
  token: localStorage.getItem('token') || '',
  email: null,
  idPerfil: null,
  nome: null,
  id: null,
  descPerfil: null
}

export default {
  status,
  userAuth,
  apiBaseUrl: (process.env.NODE_ENV === 'production') ? `${window.location.protocol}//${window.location.hostname}/api/` : 'http://localhost:5000/api/'
}
